import { Skeleton } from '@mui/material';

type CardSkeletonProps = {
	lines?: number;
};

export default function CardSkeleton({ lines = 4 }: CardSkeletonProps) {
	return (
		<div className="bg-white rounded-lg shadow-sm p-6">
			<Skeleton variant="text" width="40%" height={32} className="mb-4" />
			<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
				{Array.from({ length: lines }).map((_, i) => (
					<div key={i}>
						<Skeleton variant="text" width="60%" height={20} className="mb-1" />
						<Skeleton variant="rounded" width="80%" height={28} />
					</div>
				))}
			</div>
		</div>
	);
}
